export var addImageFallback = function (event, fallback, chain, address) {
    if (!fallbackLogo || (fallbackLogo === null || fallbackLogo === void 0 ? void 0 : fallbackLogo.includes('undefined')) || (fallbackLogo === null || fallbackLogo === void 0 ? void 0 : fallbackLogo.includes('unknown'))) {
        return;
    }
    if (fallback === null || fallback === void 0 ? void 0 : fallback.includes('placeholder')) {
        event.currentTarget.src = fallbackLogo;
        //set image opacity to 0.5
        event.currentTarget.style.opacity = '0.3';
    }
    else {
        event.currentTarget.src = fallback;
    }
};
export var fallbackLogo = '/static/geniusImages/network_logos/baseFallbackToken.png';
